import WelcomeBanner from '../../../assets/img/welcome-banner.png';

const styles = ( theme ) => ( {
  container: {
    maxWidth: '1170px',
  },
  welcomeSection: {
    padding: '30px 0',
    background: `url(${WelcomeBanner}) no-repeat`,
    backgroundSize: 'cover',
    [theme.breakpoints.down( 'xs' )]: {
      background: theme.palette.common.darkBlue,
      padding: '30px 15px',
    },
  },
  welcomeContent: {
    color: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    '& p': {
      color: theme.palette.common.white,
    },
    '& h2': {
      marginBottom: '7px',
      fontSize: 45,
    },
    '& > div': {
      width: '25%',
      '&:first-child': {
        width: '80%',
        paddingRight: '18px',
        '& h2': {
          fontSize: 35,
        },
        '& u': {
          display: 'inline-block',
          '& a': {
            color: theme.palette.common.white,
          },
        },
      },
      '&:last-child': {
        width: '160px',
        [theme.breakpoints.down( 'xs' )]: {
          width: '100%',
        },
        [theme.breakpoints.down( 'sm' )]: {
          width: '33.33%',
        },
      },
      [theme.breakpoints.down( 'sm' )]: {
        width: '33.33%',
        display: 'inline-block',
        marginBottom: '25px',
        verticalAlign: 'top',
        '&:first-child': {
          width: '100%',
          marginBottom: '25px',
        },
      },
      [theme.breakpoints.down( 'xs' )]: {
        width: '50%',
      },
    },
    [theme.breakpoints.down( 'sm' )]: {
      display: 'block',
      textAlign: 'center',
      '& h2': {
        fontSize: 25,
        lineHeight: '30px',
      },
      '& p': {
        marginTop: '15px',
      },
    },
  },
  welcomeText: {
    '& p': {
      fontSize: 14,
      fontWeight: '600',
    },
  },
  welcomeTextBlock: {
    textAlign: 'center',
    cursor: 'pointer',
    '& p': {
      fontSize: 18,
      fontWeight: '400',
      maxWidth: '160px',
      margin: '0 auto',
      '& span': {
        display: 'block',
        [theme.breakpoints.down( 'sm' )]: {
          display: 'inline',
        },
      },
    },
  },
  bannerButtonContainer: {
    marginTop: '20px',
    '& a': {
      '&:hover': {
        textDecoration: 'none',
      },
      '& button': {
        backgroundColor: theme.palette.common.white,
        fontWeight: '600',
        color: theme.palette.common.darkBlue,
        border: '1px solid transparent',
        padding: '10px 38px',
        marginRight: '20px',
        borderRadius: '0px !important',
        '&:hover': {
          backgroundColor: theme.palette.common.darkBlue,
          color: theme.palette.common.white,
          border: '1px solid #fff',
        },
        [theme.breakpoints.down( 'sm' )]: {
          marginBottom: '10px',
        },
      },
    },
  },
  whatsNewButton: {
    border: '1px solid #fff !important',
    backgroundColor: 'transparent !important',
    color: '#fff !important',
    marginRight: '20px !important',
    '&:hover': {
      backgroundColor: '#153180 !important',
    },
    [theme.breakpoints.down( 'sm' )]: {
      float: 'none !important',
      marginTop: '0px !important',
    },
  },
  pulse: {
    animation: '$pulse 2s ease-out infinite',
    animationDelay: '1.5s',
  },
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 0 0 rgba(159, 172, 186, 0.6)',
    },
    '70%': {
      boxShadow: '0 0 0 12px rgba(0, 123, 255, 0)',
    },
    '100%': {
      boxShadow: '0 0 0 0 rgba(0, 123, 255, 0)',
    },
  },
  buttonContainer: {
    position: 'relative',
  },
  publishedDate: {
    position: 'absolute',
    bottom: '-39px',
    left: 0,
    fontStyle: 'italic',
    color: '#efefef',
    fontWeight: 400,
    fontSize: '13px',
  },
  newBadge: {
    position: 'absolute',
    top: -10,
    right: 23,
    backgroundColor: '#ff3b3b',
    color: '#fff',
    fontSize: '10px',
    fontWeight: 600,
    padding: '2px 6px',
    borderRadius: '10px',
    lineHeight: 1,
    textTransform: 'uppercase',
    pointerEvents: 'none',
  },
  '@keyframes badgePulse': {
    '0%': { transform: 'scale(1)', opacity: 1 },
    '70%': { transform: 'scale(1.4)', opacity: 0 },
    '100%': { opacity: 0 },
  },
  badgePing: {
    position: 'absolute',
    top: -9,
    right: 24,
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#ff3b3b',
    animation: '$badgePulse 1.5s infinite',
  },
  badgePingStatic: {
    position: 'absolute',
    top: -8,
    right: 25,
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: '#ff3b3b',
  },
  badgePingNotification: {
    position: 'absolute',
    top: -17,
    right: 16,
    width: 9,
    height: 10,
    borderRadius: '50%',
    backgroundColor: '#ff3b3b',
  },
  outlineWrapper: {
    position: 'relative',
    display: 'inline-block',
  },

  outlineSvg: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
  },

  outlineRect: {
    fill: 'none',
    stroke: '#ffffff',
    strokeWidth: 1,
    strokeDasharray: '40 90',
    animation: '$dashMove 6s linear infinite',
  },

  '@keyframes dashMove': {
    '0%': {
      strokeDashoffset: 0,
    },
    '100%': {
      strokeDashoffset: -500,
    },
  },

  whatsNewButton2: {
    position: 'relative',
    zIndex: 1,
    border: '1px solid rgba(255,255,255,0.6)', // slightly muted
    backgroundColor: 'transparent',
    color: '#fff',
    padding: '10px 22px',
    borderRadius: 8,
  },

  '@media (prefers-reduced-motion: reduce)': {
    outlineRect: {
      animation: 'none',
    },
  },
} );

export default styles;
